import { requestJson } from '@/api/transport';
import { type ResponseMeta } from '@/api/types';
import { type CashierSession, cashierSessionSchema } from '@/schemas/cashierSession.schema';

export function getSession(
  token: string,
  signal: AbortSignal,
  onMeta?: (meta: ResponseMeta) => void,
): Promise<CashierSession> {
  return requestJson(
    `/v1/cashier/${encodeURIComponent(token)}`,
    { method: 'GET' },
    cashierSessionSchema,
    signal,
    onMeta,
  );
}

export function getStatus(
  token: string,
  signal: AbortSignal,
  onMeta?: (meta: ResponseMeta) => void,
): Promise<CashierSession> {
  return requestJson(
    `/v1/cashier/${encodeURIComponent(token)}/status`,
    { method: 'GET' },
    cashierSessionSchema,
    signal,
    onMeta,
  );
}
